import CollectionFilterKeywords from "./collection-filter-pc/collection-filter-pc-keywords";
import CollectionFilterCategories from "./collection-filter-pc/collection-filter-pc-categories";
import CollectionFilterBrands from "./collection-filter-pc/collection-filter-pc-brands";
import CollectionFilterColors from "./collection-filter-pc/collection-filter-pc-colors";
import CollectionFilterSizes from "./collection-filter-pc/collection-filter-pc-sizes";
import CollectionFilterPriceRange from "./collection-filter-pc/collection-filter-pc-price-range";
import CollectionFilterSalesTypes from "./collection-filter-pc/collection-filter-pc-sales-types";
import CollectionFilterDetails from "./collection-filter-pc/collection-filter-pc-details";
import CollectionFilterInventory from "./collection-filter-pc/collection-filter-pc-inventory";

const CollectionFilter = (el, sectionParams, onChangeFilterParams, onSubmit) => {
  let filterParams = [];
  let keywords = null;
  let categories = null;
  let brands = null;
  let colors = null;
  let sizes = null;
  let priceRange = null;
  let salesTypes = null;
  let details = null;
  let inventory = null;

  const initialize = () => {
    const elKeywords = el.querySelector(".fs-collection-filter-keywords");
    if (elKeywords) {
      keywords = CollectionFilterKeywords(elKeywords, onChangeFilterParams, onSubmit);
    }
    const elCategories = el.querySelector(".fs-collection-filter-categories");
    if (elCategories) {
      categories = CollectionFilterCategories(elCategories, sectionParams, onChangeFilterParams);
    }
    const elBrands = el.querySelector(".fs-collection-filter-brands");
    if (elBrands) {
      brands = CollectionFilterBrands(elBrands, sectionParams, onChangeFilterParams);
    }
    const elColors = el.querySelector(".fs-collection-filter-colors");
    if (elColors) {
      colors = CollectionFilterColors(elColors, onChangeFilterParams);
    }
    const elSizes = el.querySelector(".fs-collection-filter-sizes");
    if (elSizes) {
      sizes = CollectionFilterSizes(elSizes, onChangeFilterParams);
    }
    const elPriceRange = el.querySelector(".fs-collection-filter-price-range");
    if (elPriceRange) {
      priceRange = CollectionFilterPriceRange(elPriceRange, onChangeFilterParams);
    }
    const elSalesTypes = el.querySelector(".fs-collection-filter-sales-types");
    if (elSalesTypes) {
      salesTypes = CollectionFilterSalesTypes(elSalesTypes, onChangeFilterParams);
    }
    const elDetails = el.querySelector(".fs-collection-filter-details");
    if (elDetails) {
      details = CollectionFilterDetails(elDetails, onChangeFilterParams);
    }
    const elInventory = el.querySelector(".fs-collection-filter-inventory");
    if (elInventory) {
      inventory = CollectionFilterInventory(elInventory, onChangeFilterParams);
    }
  };

  const setFilterParams = (newFilterParams) => {
    filterParams = newFilterParams;
    keywords?.setFilterParams(filterParams);
    categories?.setFilterParams(filterParams);
    brands?.setFilterParams(filterParams);
    colors?.setFilterParams(filterParams);
    sizes?.setFilterParams(filterParams);
    priceRange?.setFilterParams(filterParams);
    salesTypes?.setFilterParams(filterParams);
    details?.setFilterParams(filterParams);
    inventory?.setFilterParams(filterParams);
  };

  initialize();

  return {
    setFilterParams: setFilterParams,
  };
};

export default CollectionFilter;
